import useAxios from 'axios-hooks'

// TODO: can we combine these S3 files into one...?
const V1_URL_ROOT = 'https://demo-system-next.s3.amazonaws.com/dsn-mobile-app/Helium3/web-installer/assets'
const V2_URL_ROOT = 'https://demo-system-next.s3.amazonaws.com/dxdemo/web-installer/assets'
const V1_DEV_URL_ROOT = 'https://demo-system-next.s3.amazonaws.com/dsn-mobile-app/Helium3/web-installer-dev/assets'
const IOS_VERSION_FILE = 'ios-version.txt'
const ANDROID_VERSION_FILE = 'android-version.txt'

export function useAppVersions() {
  const [{ data: data1, loading: loading1, error: error1 }] = useAxios({
    url: `${V1_URL_ROOT}/${IOS_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  const [{ data: data2, loading: loading2, error: error2 }] = useAxios({
    url: `${V1_URL_ROOT}/${ANDROID_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  const [{ data: data3, loading: loading3, error: error3 }] = useAxios({
    url: `${V2_URL_ROOT}/${IOS_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  const [{ data: data4, loading: loading4, error: error4 }] = useAxios({
    url: `${V2_URL_ROOT}/${ANDROID_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  return {
    data: {
      v1: { iOS: data1, android: data2 },
      v2: { iOS: data3, android: data4 },
    },
    loading: loading1 || loading2 || loading3 || loading4,
    error: error1 || error2 || error3 || error4,
  }
}

export function useDevAppVersions() {
  const [{ data: dataIos, loading: loadingIos, error: errorIos }] = useAxios({
    url: `${V1_DEV_URL_ROOT}/${IOS_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  const [{ data: dataAndroid, loading: loadingAndroid, error: errorAndroid }] = useAxios({
    url: `${V1_DEV_URL_ROOT}/${ANDROID_VERSION_FILE}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  })

  return {
    data: { iOS: dataIos, android: dataAndroid },
    loading: loadingIos || loadingAndroid,
    error: errorIos || errorAndroid,
  }
}
